export default __webpack_public_path__ + "static/20250725-03af25d3bb9ea262ff3b0a90f2391078.png";